export default "__VITE_ASSET__DTBbkukJ__"